module.exports = __webpack_public_path__ + "static/media/recommended_tag.885fa308.svg";